<template>
    <section id="sections" class="sections-block">
        <v-container class="block-container">
            <div class="section-meta">
                <span class="chapter-num">01</span>
                <span class="chapter-divider"></span>
                <span class="chapter-eyebrow">{{ $t('team.sections.title') }}</span>
            </div>

            <h2 class="block-title" v-html="$t('team.page.sections_headline')"></h2>

            <div class="section-tabs">
                <button
                    v-for="section in sections"
                    :key="section.key"
                    class="section-tab"
                    :class="{ 'is-active': activeKey === section.key }"
                    @click="activeKey = section.key">
                    <span v-if="section.num" class="tab-num">{{ section.num }}</span>
                    <span class="tab-name">{{ $t(section.nameKey) }}</span>
                </button>
            </div>

            <div class="section-detail">
                <div class="detail-text">
                    <h3 class="detail-title">{{ $t(active.nameKey) }}.</h3>
                    <div class="detail-blurb" v-html="sectionDescription(active.key)"></div>
                </div>

                <div class="detail-coordinators">
                    <div class="coordinators-grid">
                        <div
                            v-for="(person, i) in active.coordinators"
                            :key="i"
                            class="coordinator-card">
                            <div class="coord-photo">
                                <img :src="person.photo" :alt="person.name" />
                            </div>
                            <div class="coord-info">
                                <span class="coord-role">{{ $t('team.roles.' + person.roleKey) }}</span>
                                <span class="coord-name">{{ person.name }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </v-container>
    </section>
</template>

<script>
    export default {
        name: "SectionsComponent",
        data() {
            return {
                activeKey: 'main',
                sections: [
                    {
                        key: 'main',
                        num: '',
                        nameKey: 'team.sections_details.main.name',
                        descKey: 'team.sections_details.main.short_description',
                        coordinators: [
                            { name: 'Michał Zawada', roleKey: 'main_coordinator', photo: require('@/assets/img/components/team/team_photos/Michal Zawada.webp') },
                            { name: 'Kinga Rokosz', roleKey: 'vice_main_coordinator', photo: require('@/assets/img/components/team/team_photos/Kinga Rokosz.webp') }
                        ]
                    },
                    {
                        key: 'construction',
                        num: '01',
                        nameKey: 'team.sections_details.construction.name',
                        descKey: 'team.sections_details.construction.short_description',
                        coordinators: [
                            { name: 'Kacper Ćwiokowski', roleKey: 'section_coordinator', photo: require('@/assets/img/components/team/team_photos/Kacper Cwiokowski.webp') }
                        ]
                    },
                    {
                        key: 'composites',
                        num: '02',
                        nameKey: 'team.sections_details.composites.name',
                        descKey: 'team.sections_details.composites.short_description',
                        coordinators: [
                            { name: 'Karolina Machowska', roleKey: 'section_coordinator_f', photo: require('@/assets/img/components/team/team_photos/Karolina Machowska.webp') },
                            { name: 'Oskar Antonik', roleKey: 'section_coordinator', photo: require('@/assets/img/components/team/team_photos/Oskar Antonik.webp') }
                        ]
                    },
                    {
                        key: 'electricity',
                        num: '03',
                        nameKey: 'team.sections_details.electricity.name',
                        descKey: 'team.sections_details.electricity.short_description',
                        coordinators: [
                            { name: 'Dawid Stęposz', roleKey: 'section_coordinator', photo: require('@/assets/img/components/team/team_photos/Dawid Steposz.webp') },
                            { name: 'Hubert Kraj', roleKey: 'section_coordinator', photo: require('@/assets/img/components/team/team_photos/Hubert Kraj.webp') }
                        ]
                    },
                    {
                        key: 'embedded',
                        num: '04',
                        nameKey: 'team.sections_details.embedded.name',
                        descKey: 'team.sections_details.embedded.short_description',
                        coordinators: [
                            { name: 'Michał Zawada', roleKey: 'section_coordinator', photo: require('@/assets/img/components/team/team_photos/Michal Zawada.webp') }
                        ]
                    },
                    {
                        key: 'autonomic',
                        num: '05',
                        nameKey: 'team.sections_details.autonomic.name',
                        descKey: 'team.sections_details.autonomic.short_description',
                        coordinators: [
                            { name: 'Filip Nawalaniec', roleKey: 'section_coordinator', photo: require('@/assets/img/components/team/team_photos/Filip Nawalaniec.webp') },
                            { name: 'Julia Czekańska', roleKey: 'section_coordinator_f', photo: require('@/assets/img/components/team/team_photos/Julia Czekanska.webp') }
                        ]
                    },
                    {
                        key: 'marketing',
                        num: '06',
                        nameKey: 'team.sections_details.marketing.name',
                        descKey: 'team.sections_details.marketing.short_description',
                        coordinators: [
                            { name: 'Anita Uzar', roleKey: 'section_coordinator_f', photo: require('@/assets/img/components/team/team_photos/Anita Uzar.webp') }
                        ]
                    }
                ]
            }
        },
        computed: {
            active() {
                return this.sections.find(s => s.key === this.activeKey) || this.sections[0]
            }
        },
        methods: {
            sectionDescription(key) {
                const descriptionKey = `team.sections_details.${key}.description`;
                if (this.$te(descriptionKey)) {
                    return this.$t(descriptionKey);
                }
                return this.$t(`team.sections_details.${key}.short_description`);
            }
        }
    }
</script>

<style lang="sass" scoped>
    .sections-block
        background: #ffffff
        color: #0a0828
        padding: 140px 0
        font-family: Inter, sans-serif

    .block-container
        max-width: 1280px !important
        padding: 0 56px !important

    .section-meta
        display: flex
        align-items: center
        gap: 18px
        margin-bottom: 36px
        font-size: 12px
        font-weight: 500
        letter-spacing: 0.22em
        text-transform: uppercase

        .chapter-num
            font-family: Raleway, sans-serif
            font-weight: 700
            font-size: 14px
            letter-spacing: 0.1em

        .chapter-divider
            width: 36px
            height: 1px
            background: #0a0828
            opacity: 0.4

        .chapter-eyebrow
            opacity: 0.85

    .block-title
        font-family: Raleway, sans-serif
        font-weight: 900
        font-size: clamp(40px, 6vw, 88px)
        line-height: 0.98
        letter-spacing: -0.025em
        margin: 0 0 64px
        color: #0a0828
        text-transform: lowercase

    .section-tabs
        display: flex
        flex-wrap: wrap
        gap: 8px
        margin-bottom: 64px
        padding-bottom: 28px
        border-bottom: 1px solid rgba(10, 8, 40, 0.12)

        .section-tab
            display: inline-flex
            align-items: center
            gap: 10px
            padding: 12px 22px
            border: 1px solid rgba(10, 8, 40, 0.2)
            border-radius: 999px
            background: transparent
            color: rgba(10, 8, 40, 0.7)
            font-family: Inter, sans-serif
            font-size: 13px
            font-weight: 500
            letter-spacing: 0.06em
            cursor: pointer
            transition: all 0.2s ease

            &:hover
                border-color: rgba(10, 8, 40, 0.5)
                color: #0a0828

            &.is-active
                background: #0a0828
                border-color: #0a0828
                color: #fff

                .tab-num
                    color: rgba(255, 255, 255, 0.6)

            .tab-num
                font-family: Raleway, sans-serif
                font-weight: 700
                font-size: 11px
                letter-spacing: 0.1em
                color: rgba(10, 8, 40, 0.45)
                transition: color 0.2s ease

            .tab-name
                font-weight: 500

    .section-detail
        display: grid
        grid-template-columns: 5fr 7fr
        gap: 80px
        align-items: start

    .detail-text
        position: sticky
        top: 100px

        .detail-title
            font-family: Raleway, sans-serif
            font-weight: 900
            font-size: clamp(32px, 4vw, 56px)
            line-height: 1.02
            letter-spacing: -0.02em
            margin: 0 0 24px
            color: #0a0828
            text-transform: lowercase

        .detail-blurb
            font-size: clamp(15px, 1.1vw, 17px)
            line-height: 1.7
            color: rgba(10, 8, 40, 0.78)
            margin: 0
            text-indent: 0

            ::v-deep p
                margin: 0 0 14px

                &:last-child
                    margin-bottom: 0

    .coordinators-grid
        display: grid
        grid-template-columns: repeat(auto-fill, minmax(160px, 1fr))
        gap: 32px

    .coordinator-card
        display: flex
        flex-direction: column
        gap: 14px

        .coord-photo
            position: relative
            aspect-ratio: 3 / 4
            overflow: hidden

            img
                display: block
                width: 100%
                height: 100%
                object-fit: cover
                object-position: center top
                transition: transform 0.4s ease

        &:hover .coord-photo img
            transform: scale(1.03)

        .coord-info
            display: flex
            flex-direction: column
            gap: 4px
            text-align: left

            .coord-role
                font-size: 11px
                font-weight: 500
                letter-spacing: 0.18em
                text-transform: uppercase
                color: rgba(10, 8, 40, 0.55)

            .coord-name
                font-family: Raleway, sans-serif
                font-weight: 700
                font-size: 16px
                color: #0a0828

    @media (max-width: 960px)
        .sections-block
            padding: 90px 0

        .block-container
            padding: 0 28px !important

        .block-title
            margin-bottom: 40px

        .section-tabs
            margin-bottom: 48px
            padding-bottom: 20px

            .section-tab
                padding: 10px 18px
                font-size: 12px

        .section-detail
            grid-template-columns: 1fr
            gap: 48px

        .detail-text
            position: static

        .coordinators-grid
            grid-template-columns: repeat(auto-fill, minmax(130px, 1fr))
            gap: 24px
</style>
